import React, { useEffect, useRef, useState } from 'react';
import SupplierFilters from '../SupplierFilters/SupplierFilters';
import { ProductCard } from 'components/Product';
import { QueryParams, SupplierOrderListProps } from 'types';
import { useGetProductsQuery } from 'services';
import { Spin } from 'antd';
import useDebounce from 'hooks/useDebounce';

const SupplierOrderList: React.FC<SupplierOrderListProps> = ({
  form,
  selectedSupplierId,
  setSelectedSupplierId,
  className,
  initItems,
}) => {
  const [size, setSize] = useState(9);
  const [searchName, setSearchName] = useState<string>('');
  const [searchCategory, setSearchCategory] = useState<string>('');
  const [priceRange, setPriceRange] = useState<number[]>([]);
  const [sortValue, setSortValue] = useState<string>('updatedAt:desc');

  const productVersionIds = initItems ? Object.keys(initItems) : [];
  useEffect(() => {
    console.log('initItems:', initItems);
    console.log('productVersionIds:', productVersionIds);
  }, [initItems]);
  const filters = [
    'isActive:eq:true',
    // searchName && `name:like:${searchName}`,
    searchCategory && `categoryId:eq:${searchCategory}`,
    priceRange[0] && `salePrice:gte:${priceRange[0]}`,
    priceRange[1] && `salePrice:lte:${priceRange[1]}`,
    productVersionIds &&
      productVersionIds?.length > 0 &&
      `id:in:[${productVersionIds.map((item) => `"${item}"`).join(',')}]`,

    // selectedSupplierId && `baseUnitId:eq:${selectedSupplierId}`,
  ]
    .filter(Boolean)
    .join('&&');

  const { data, refetch, isFetching } = useGetProductsQuery({
    query: {
      size,
      include: 'product.productVersions|category|brand|currencyUnit|productImages.image',
      filter: !productVersionIds ? filters : filters,
      sort: sortValue,
      supplierId: selectedSupplierId,
      searchKey: 'name|color|dimension|sizeSpec|product.code',
      searchValue: searchName,
    } as QueryParams,
  });

  const debouncedSetSearchName = useDebounce((value: unknown) => {
    setSearchName(value as string);
  }, 400);

  const products = data?.data?.rows ?? [];
  const totalCount = data?.data?.count ?? 0;

  const hasMore = products.length < totalCount && products.length > 0;

  const loadMoreRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    refetch();
  }, [priceRange, refetch, selectedSupplierId]);

  useEffect(() => {
    setSize(9);
  }, [searchName, searchCategory, priceRange, sortValue, selectedSupplierId]);

  useEffect(() => {
    if (!loadMoreRef.current || !hasMore || isFetching) return;

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasMore && !isFetching) {
          setSize((prev) => prev + 9);
        }
      },
      {
        threshold: 0.1,
        rootMargin: '20px',
      },
    );

    const current = loadMoreRef.current;
    observer.observe(current);

    return () => {
      observer.unobserve(current);
    };
  }, [hasMore, isFetching]);

  return (
    <div className={`w-full ${className}`}>
      <SupplierFilters
        form={form}
        selectedSupplierId={selectedSupplierId}
        setSelectedSupplierId={setSelectedSupplierId}
        debouncedSetSearchName={debouncedSetSearchName}
        setSearchCategory={setSearchCategory}
        setPriceRange={setPriceRange}
        priceRange={priceRange}
        setSortValue={setSortValue}
      />
      <div className='overflow-y-auto max-h-[calc(100vh-270px)] min-h-[calc(100vh-270px)]'>
        <div className='p-3 grid grid-cols-2 xl:grid-cols-3 gap-4 2xl:gap-8 overflow-y-auto'>
          {products.map((product) => (
            <ProductCard key={product.id} product={product} itemQuantity={initItems ? initItems[product.id] : 0} />
          ))}
        </div>

        {isFetching && products.length > 0 && (
          <div className='text-center py-4 text-gray-500'>
            <Spin />
          </div>
        )}

        {/* Load more trigger element */}
        {hasMore && !isFetching && <div ref={loadMoreRef} className='text-center py-4 text-gray-500 h-10'></div>}

        {!hasMore && products.length > 0 && (
          <div className='text-center py-4 text-gray-400 text-sm'>Đã hiển thị tất cả sản phẩm</div>
        )}
      </div>
    </div>
  );
};

export default SupplierOrderList;
